// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "td.options[data-v-e014fa72]{width:50px;text-align:right}.vet-pagination[data-v-e014fa72]{margin-top:50px}", ""]);
// Exports
module.exports = exports;
